module.exports = __webpack_public_path__ + "static/assets/59d4bb932f52f637d8cb0228e85c44f0.png";